import React, { useState, useEffect } from 'react';
import './App.css';
import { useTheme } from './ThemeContext';
import BottomNav from './components/BottomNav';
import SalesFeed from './components/SalesFeed';
import ConnectionStatus, { WebSocketProvider, useWebSocket } from './components/WebSocketContext';
import { useLocation } from 'react-router-dom';
import { useFilter } from './components/FilterContext';
import { useAuth } from './components/AuthContext';

function App() {
  const { theme } = useTheme();
  const themeClass = theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark';
  document.body.className = `App ${themeClass}`;

  const location = useLocation();
  const [targetArticle, setTargetArticle] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const articleFromUrl = params.get('article');
    if (articleFromUrl) {
      setTargetArticle(articleFromUrl);
    } else {
      setTargetArticle(null); // Если нет параметра article, просто null
    }
  }, [location]);

  return (
    <WebSocketProvider>

      <MainContent targetArticle={targetArticle} />

    </WebSocketProvider>
  );
}

const MainContent = ({ targetArticle }) => {
  const { theme } = useTheme();
  const { userInfo } = useAuth();
  const { sales, feedbackSales, subscriptionEnded } = useWebSocket();
  const { showFeedbackOnly } = useFilter();
  const [salesData, setSalesData] = useState([]);
  const canShowSales = userInfo?.status === true && !subscriptionEnded;

  useEffect(() => {
    const source = showFeedbackOnly ? feedbackSales : sales;
    if (source !== null) {
      setSalesData(source);
    }
  }, [sales, feedbackSales, showFeedbackOnly]);

  return (
    <div className={`min-vh-100 main-content app-main-page ${theme === 'dark' ? 'app-main-page--dark' : 'app-main-page--light'}`}>
      <div className={`main-status-glass ${theme === 'dark' ? 'main-status-glass--dark' : 'main-status-glass--light'}`} aria-hidden="true" />
      <ConnectionStatus />

      {canShowSales && (
        <SalesFeed sales={salesData} type='ws' targetArticle={targetArticle} />
      )}
      <BottomNav />
    </div>
  );
};

export default App;
